<template>
  <v-container
    fluid
    class="pa-0 ma-0"
  >
    <v-row
      v-if="$route.name !== 'temps-synthese'"
      no-gutters
    >
      <v-fade-transition mode="out-in">
        <v-col
          cols="12"
          class="ma-0 pa-0"
        >
          <router-view />
        </v-col>
      </v-fade-transition>
    </v-row>
    <v-row v-else>
      <v-col
        cols="12"
      >
        <v-container fluid>
          <v-row no-gutters>
            <v-col cols="12">
              <MainTitle
                title="Synthèse"
                icon="mdi-chart-pie"
                :loading="loading"
              >
                <template v-slot:end-of-toolbar>
                  <v-hover>
                    <v-btn
                      slot-scope="{ hover }"
                      rounded
                      small
                      :color="hover?'blue':'black'"
                      @click="executeQuery"
                    >
                      <v-icon
                        dark
                        :left="!$vuetify.breakpoint.smAndDown"
                      >
                        mdi-refresh
                      </v-icon>
                      <span class="hidden-sm-and-down">Actualiser</span>
                    </v-btn>
                  </v-hover>
                </template>
              </MainTitle>
            </v-col>
            <v-col
              cols="12"
              class="mt-3"
            >
              <v-card>
                <v-card-text class="text-center ma-0 pa-1">
                  <v-dialog
                    v-model="modalMonth"
                    :return-value="currentMonth"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-row
                        no-gutters
                        align="center"
                      >
                        <v-col
                          cols="12"
                          md="4"
                          class="hidden-sm-and-down ma-0 pa-0 text-left"
                        >
                          <v-hover v-slot:default="{ hover }">
                            <v-btn
                              small
                              class="ml-1"
                              :color="hover?'blue':null"
                              :disabled="loading"
                              @click="previousMonth"
                            >
                              <v-icon left>
                                mdi-chevron-left
                              </v-icon>
                              <span class="hidden-sm-and-down">{{ textPreviousMonth }}</span>
                            </v-btn>
                          </v-hover>
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          sm="12"
                          class="text-center ma-0 pa-0"
                        >
                          <v-text-field
                            v-model="currentMonthFr"
                            :disabled="loading"
                            prepend-icon="mdi-calendar-range"
                            readonly
                            :full-width="false"
                            hide-details
                            class="ma-0 pa-0"
                            v-on="on"
                          />
                        </v-col>
                        <v-col
                          cols="12"
                          md="4"
                          class="hidden-sm-and-down ma-0 pa-0 text-right"
                        >
                          <v-hover v-slot:default="{ hover }">
                            <v-btn
                              small
                              class="mr-1"
                              :color="hover?'blue':null"
                              :disabled="loading"
                              @click="nextMonth"
                            >
                              <span class="hidden-sm-and-down">{{ textNextMonth }}</span>
                              <v-icon right>
                                mdi-chevron-right
                              </v-icon>
                            </v-btn>
                          </v-hover>
                        </v-col>
                      </v-row>
                    </template>
                    <v-date-picker
                      v-model="currentMonth"
                      scrollable
                      first-day-of-week="1"
                      :disabled="loading"
                      type="month"
                    >
                      <v-spacer />
                      <v-btn
                        text
                        color="primary"
                        @click="modalMonth = false"
                      >
                        Annuler
                      </v-btn>
                    </v-date-picker>
                  </v-dialog>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              v-if="!loading"
              cols="12"
              class="mt-3"
            >
              <v-card class="elevation-2">
                <v-card-title class="ma-0 pa-0 pl-3 pr-3">
                  <v-col cols="12">
                    <v-row
                      no-gutters
                      align="start"
                      justify="start"
                    >
                      <v-col :cols="$vuetify.breakpoint.xs?12:false">
                        Sythèse du mois de {{ currentMonthFr }}
                      </v-col>
                    </v-row>
                  </v-col>
                </v-card-title>
                <v-card-text>

                  <v-row
                    v-if="clients.length"
                    no-gutters
                    class="pt-3 pb-3"
                  >
                    <v-col
                      cols="auto"
                    >
                      Trier les dossiers de client par...
                    </v-col>
                    <v-spacer />
                    <v-col
                      cols="auto"
                      class="pr-1 subtitle-2 font-weight-regular"
                    >
                      Numéro de dossier
                    </v-col>
                    <v-col
                      cols="auto"
                    >
                      <v-switch
                        v-model="trierParNumeroDossier"
                        color="grey"
                        class="ma-0 pa-0"
                        hide-details
                        dense
                      />
                    </v-col>
                    <v-col
                      cols="auto"
                      class="subtitle-2 font-weight-regular"
                    >
                      Nom du dossier
                    </v-col>
                  </v-row>
                  <v-card
                    v-for="client in clients"
                    :key="client.clientId"
                    class="mt-4 mb-6 elevation-3"
                  >
                    <v-card-title :class="(!client.tasks.length || (client.joursEnErreurs && client.joursEnErreurs.length) ? 'orange lighten-4':client.dossiers.length ? 'light-green lighten-4':'grey lighten-2') + ' elevation-2 pa-0'">
                      <v-row
                        no-gutters
                        align="space-between"
                        justify="space-between"
                      >
                        <v-col
                          cols="auto"
                          class="pa-2"
                        >
                          <v-icon
                            :color="client.couleur ? client.couleur : 'grey'"
                            left
                            size="30"
                          >
                            mdi-briefcase-account
                          </v-icon>

                          <v-icon
                            v-if="(!client.tasks.length ||(client.joursEnErreurs && client.joursEnErreurs.length))"
                            large
                            color="orange"
                          >
                            mdi-alert
                          </v-icon>
                          {{ client.libelle }}
                        </v-col>
                        <v-col
                          v-if="hasPermission('ROLE_TEMPS_EXPORT_SHOW')"
                          class="text-right ma-0 pa-0 pl-2 pr-2"
                          cols="auto"
                        >
                          <v-btn
                            :loading="loadingExcel"
                            :disabled="loadingExcel"
                            clas="ma-0"
                            @click="exportClient(client)"
                          >
                            <v-icon
                              :left="!$vuetify.breakpoint.smAndDown"
                              color="green"
                            >
                              mdi-file-excel
                            </v-icon>
                            Relevé d'heures
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card-title>
                    <v-card-text class="ma-0 pa-0 pt-1">
                      <v-row no-gutters>
                        <v-col
                          v-if="!client.dossiers.length"
                          cols="12"
                          class="text-center grey--text font-italic"
                        >
                          Aucun dossier présent pour ce client. Veuillez en ajouter un dans la configuration pour pouvoir ajouter des heures.
                        </v-col>
                        <v-col
                          :cols="12"
                        >
                          <v-simple-table
                            v-if="client.tasks.length && client.dossiers.length"
                            class="ma-0 pa-0"
                          >
                            <template v-slot:default>
                              <thead>
                                <tr>
                                  <th class="text-left">
                                    <v-row no-gutters>
                                      <v-col cols="12">
                                        Dossiers
                                      </v-col>
                                      <v-col
                                        v-if="client.dossiers && client.dossiers.length"
                                        cols="auto"
                                        class="pr-1 subtitle-2 font-weight-regular"
                                      >
                                        Euros
                                      </v-col>
                                      <v-col
                                        v-if="client.dossiers && client.dossiers.length"
                                        cols="auto"
                                      >
                                        <v-switch
                                          v-model="vueHeure"
                                          color="grey"
                                          class="ma-0 pa-0"
                                          hide-details
                                          dense
                                        />
                                      </v-col>
                                      <v-col
                                        v-if="client.dossiers && client.dossiers.length"
                                        cols="auto"
                                        class="subtitle-2 font-weight-regular"
                                      >
                                        Heures
                                      </v-col>
                                    </v-row>
                                  </th>
                                  <th
                                    v-for="task in client.tasks"
                                    :key="task.taskId"
                                    class="text-center"
                                  >
                                    {{ task.libelle }}
                                  </th>
                                  <th
                                    class="text-center subtitle-1 font-weight-bold grey lighten-3 text-no-wrap"
                                    colspan="2"
                                  >
                                    <v-icon
                                      size="22"
                                      left
                                    >
                                      mdi-sigma
                                    </v-icon>Totaux
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="dossier in client.dossiers"
                                  :key="dossier.dossierId"
                                >
                                  <td class="text-no-wrap">
                                    <v-icon
                                      :color="dossier.couleur ? getColorWithLuminosite(dossier.couleur, -0.5) : 'grey'"
                                      size="22"
                                      left
                                    >
                                      mdi-folder
                                    </v-icon>

                                    <v-icon
                                      v-if="dossier.erreur"
                                      color="orange"
                                      left
                                    >
                                      mdi-alert
                                    </v-icon>
                                    <span class="font-weight-black">{{ dossier.libelle }}</span> <span class="grey--text caption" v-if="dossier.numero">({{dossier.numero}})</span>
                                  </td>
                                  <td
                                    v-for="task in client.tasks"
                                    :key="task.taskId"
                                    class="text-center"
                                  >
                                    {{ toHeureOrEuro(client.valeurs[dossier.dossierId+'/'+task.taskId]?client.valeurs[dossier.dossierId+'/'+task.taskId][vueHeure?'duree':'euro']:0, vueHeure) }}
                                  </td>
                                  <td class="subtitle-1 text-center font-weight-bold grey lighten-3">
                                    {{ toHeureOrEuro(dossier.totaux?dossier.totaux.duree:0, true) }}
                                  </td>
                                  <td class="subtitle-1 text-center font-weight-bold grey lighten-3">
                                    {{ toHeureOrEuro(dossier.totaux?dossier.totaux.euro:0, false) }}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    class="font-weight-black grey lighten-3"
                                    rowspan="2"
                                  >
                                    <v-icon
                                      size="22"
                                      left
                                    >
                                      mdi-sigma
                                    </v-icon>
                                    Totaux
                                  </td>
                                  <td
                                    v-for="task in client.tasks"
                                    :key="task.taskId"
                                    class="text-center subtitle-1  font-weight-bold grey lighten-3"
                                  >
                                    {{ toHeureOrEuro(task.totaux?task.totaux.duree:0, true) }}
                                  </td>
                                  <td class="subtitle-1 text-center font-weight-bold grey lighten-3">
                                    {{ toHeureOrEuro(client.totaux?client.totaux.duree:0, true) }}
                                  </td>
                                  <td class="subtitle-1 text-center font-weight-bold grey lighten-3" />
                                </tr>
                                <tr>
                                  <td
                                    v-for="task in client.tasks"
                                    :key="task.taskId"
                                    class="text-center subtitle-1  font-weight-bold grey lighten-3"
                                  >
                                    {{ toHeureOrEuro(task.totaux?task.totaux.euro:0, false) }}
                                  </td>
                                  <td class="subtitle-1 text-center font-weight-bold grey lighten-3" />
                                  <td class="subtitle-1 text-center font-weight-bold grey lighten-3">
                                    {{ toHeureOrEuro(client.totaux?client.totaux.euro:0, false) }}
                                  </td>
                                </tr>
                              </tbody>
                            </template>
                          </v-simple-table>

                          <v-alert
                            v-if="client.joursEnErreurs && client.joursEnErreurs.length"
                            border="right"
                            colored-border
                            type="error"
                            elevation="2"
                            class="ma-3 text-center"
                          >
                            <span v-if="client.joursEnErreurs.length>1">Attention, des erreurs de saisies ont été détectées.<br> Veuillez régulariser les jours suivant :</span>
                            <span
                              v-else
                              class="orange--text"
                            >Attention, une erreur de saisie a été détectée. <br>Veuillez la régulariser sur cette journée :</span>
                            <br>
                            <v-btn
                              v-for="jour in client.joursEnErreurs"
                              :key="jour.jour"
                              class="mr-2"
                              :to="{ name:'temps-saisie', query: { day: jour.jour }}"
                            >
                              <v-icon left>
                                mdi-pencil
                              </v-icon> {{ dayHuman(jour.jour) }}
                            </v-btn>
                            <br>
                            <div class="grey--text font-italic caption mt-3">
                              Vous pouvez ouvrir la page de saisie de la date concerné en cliquant sur le bouton tout en maintenant la touche Shift enfoncé.
                              <br>Une fois régularisé, cliquez sur ce bouton <br><v-btn
                                text
                                small
                                @click="executeQuery"
                              >
                                <v-icon left>
                                  mdi-refresh
                                </v-icon>Actualiser
                              </v-btn>
                            </div>
                          </v-alert>
                        </v-col>
                        <v-col
                          v-if="!(client.joursEnErreurs && client.joursEnErreurs.length)"
                          cols="12"
                        >
                          <JSCharting
                            v-if="client.dossiers.length>1 && client.tasks.length"
                            :options="generateChartOptionsForClientPerDossiers(client)"
                            class="columnChart"
                            mutable
                          />
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import MainTitle from '../Common/MainTitle'
import JSCharting from 'jscharting-vue'
import * as Color from 'color'

export default {
  components: { MainTitle, JSCharting },
  data: () => {
    return {
      trierParNumeroDossier: true,
      currentMonth: null,
      modalMonth: false,
      vueHeure: true
    }
  },
  computed: {
    ...mapState('worktools/temps', ['tempsRetrieveState', 'tempsRetrieveRecords', 'downloadExcelState']),
    ...mapGetters('user', ['hasPermission']),
    loading () {
      return this.tempsRetrieveState === 'in-progress'
    },
    loadingExcel () {
      return this.downloadExcelState === 'in-progress'
    },
    clients () {
      if (this.loading) {
        return []
      }
      let records = this.tempsRetrieveRecords && this.tempsRetrieveRecords.clients ? this.tempsRetrieveRecords.clients : []
      let champ = this.trierParNumeroDossier ? 'numero' : 'libelle'
      return records.map(row => {
        row.dossiers = row.dossiers.sort((a, b) => (a[champ] > b[champ]) ? 1 : -1)
        return row
      })
    },
    currentMonthFr () {
      if (!this.currentMonth) {
        return null
      }
      let dateFr = this.$moment(this.currentMonth + '-01').format('MMMM YYYY')
      return dateFr ? (dateFr[0].toUpperCase() + dateFr.slice(1)) : null
    },
    textPreviousMonth () {
      return this.$moment(this.currentMonth + '-01').add(-1, 'month').format('MMMM YYYY')
    },
    textNextMonth () {
      return this.$moment(this.currentMonth + '-01').add(1, 'month').format('MMMM YYYY')
    }
  },
  watch: {
    currentMonth (value) {
      this.modalMonth = false
      if (this.$route.name !== 'temps-synthese') {
        return
      }
      let newMonth = value ? this.$moment(value).format('YYYY-MM') : null
      if (this.$route.query.month === newMonth) {
        return
      }
      this.$router.replace({
        name: 'temps-synthese',
        query: {
          month: newMonth
        }
      })
      this.executeQuery()
    },
    '$route' (newRoute, oldRoute) {
      if (newRoute.name !== oldRoute.name) {
        if (newRoute.query.month && newRoute.query.month !== this.currentMonth) {
          this.currentMonth = newRoute.query.month
        }
        this.executeQuery()
      }
    }
  },
  mounted () {
    if (!this.currentMonth && this.$route.query && this.$route.query.month) {
      this.currentMonth = this.$route.query.month
    }
    if (!this.currentMonth) {
      this.currentMonth = this.$moment().format('YYYY-MM')
    }
    this.executeQuery()
  },
  methods: {
    ...mapActions('worktools/temps', ['retrieveTempsForMonth', 'makeExcelExportMois']),
    executeQuery () {
      this.retrieveTempsForMonth({
        month: this.currentMonth
      })
    },
    previousMonth () {
      this.currentMonth = this.$moment(this.currentMonth + '-01').add(-1, 'month').format('YYYY-MM')
    },
    nextMonth () {
      this.currentMonth = this.$moment(this.currentMonth + '-01').add(1, 'month').format('YYYY-MM')
    },
    generateChartOptionsForClientPerDossiers (client) {
      return {
        legend_visible: false,
        defaultSeries: { type: 'pie', pointSelection: true },
        series: [
          {
            points: client.dossiers.map(dossier => ({
              y: dossier.totaux[this.vueHeure ? 'duree' : 'euro'],
              color: this.getColorWithLuminosite(dossier.couleur, -0.5),
              tooltip: this.toHeureOrEuro(dossier.totaux[this.vueHeure ? 'duree' : 'euro'], this.vueHeure) + ' pour le dossier ' + dossier.libelle
            }))
          }
        ]
      }
    },
    getColorWithLuminosite (couleur, taux) {
      return !couleur ? null : Color(couleur)[taux < 0 ? 'darken' : 'lighten'](taux < 0 ? -taux : taux).hex()
    },
    toHeureOrEuro (valeur, formatToHeure) {
      if (!valeur && valeur !== 0) {
        return null
      }
      if (formatToHeure) {
        let heure = Math.floor(valeur)
        let minute = Math.floor((valeur - heure) * 60)

        return (heure < 10 ? '0' + heure : heure) + 'h' + (minute < 10 ? '0' + minute : minute)
      }
      let formatter = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      })

      return formatter.format(valeur)
    },
    dayHuman (date) {
      return this.$moment(date).format('dddd d MMMM YYYY')
    },
    exportClient (client) {
      this.makeExcelExportMois({
        mois: this.currentMonth,
        clientId: client.clientId,
        fileName: 'Exportation ' + client.libelle + ' ' + this.currentMonthFr
      })
    }
  }
}
</script>

<style>
  .columnChart {
    height: 300px;
  }
  SVG g #brandingLogo {
    display: none !important
  }
</style>
